import useAlert from '@/components/Alert/hooks/useAlert'
import Storage from '@/lib/Storage'
import { useRedirect } from 'react-admin'
import createAffiliate from '../repository/createAffiliate'
import { subscribeAffiliate } from '../repository/subscribeAffiliate'
import SignUpFormValues from '../types/SignUpFormValues'

const SUCCESS_REDIRECT = '/login'
const SUCCESS_MESSAGE = 'Affiliate account created successfully!'

const useAffiliates = () => {
  const { getRecaptchaToken } = Storage()
  const { alertError, alertSuccess } = useAlert()

  const redirect = useRedirect()

  const signUp = async (values: SignUpFormValues) => {
    const recaptchaToken = getRecaptchaToken() || ''

    await createAffiliate(values, recaptchaToken)
      .then(() => {
        alertSuccess(SUCCESS_MESSAGE)
        subscribeAffiliate({
          email: values.email,
          first_name: values.first_name,
          last_name: values.last_name
        })
        redirect(SUCCESS_REDIRECT)
      })
      .catch(({ message }) => alertError(message))
  }

  return {
    signUp
  }
}

export default useAffiliates
